module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['alert', 'alert-' + _vm.type, {
      'alert-dismissible': _vm.dismissible
    }]
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _c('h4', [_c('i', {
    class: ['icon', _vm.iconClasses]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5302666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Alert.vue
// module id = 1924
// module chunks = 1